var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5956",
    "data-name": "Group 5956",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    fill: "#fff",
    stroke: "#e10092",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.75,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25567",
    "data-name": "Path 25567",
    d: "M2.283,6.1,0,0H2.283l1.26,3.638L4.842,0H7.173L4.842,6.1Z",
    transform: "translate(4 10.722) rotate(-90)",
    fill: "#e10092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcons);
export default __webpack_public_path__ + "static/media/right-icons.3066e9049b85afa8f72a2fcd59e56745.svg";
export { ForwardRef as ReactComponent };